import { render, staticRenderFns } from "./ForumDetails.vue?vue&type=template&id=3d0d1294&"
import script from "./ForumDetails.vue?vue&type=script&lang=js&"
export * from "./ForumDetails.vue?vue&type=script&lang=js&"
import style0 from "./ForumDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports